export default __webpack_public_path__ + "static/media/stack-icon.124283f6.svg";